import React, { ReactElement } from 'react';
import { ErrorPageContainer, ErrorContentContainer, ErrorStyledIcon } from 'pages/styles';

export const NoCustomPPErrorPage = (): ReactElement => {
  const errorText = 'Die Datenschutzrichtlinie ist für den Händler nicht verfügbar.';
  return (
    <ErrorPageContainer>
      <ErrorContentContainer>
        <div>
          <ErrorStyledIcon />
        </div>
        <p>{errorText}</p>
      </ErrorContentContainer>
    </ErrorPageContainer>
  );
};
